import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import { Box, Paper } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import AddOrEditButton from './AddOrEditButton';
import QuantityButton from './QuantityButton';

interface BottomActionProps {
    restaurantOfferStore: RestaurantOfferStore
}

const BottomAction: React.FC<BottomActionProps> = observer(({ restaurantOfferStore }) => {
    return (
        <Paper
            elevation={0}
            sx={{
                position: "fixed",
                bottom: { xs: 0, sm: 16 },
                // right: 0,
                pb: { xs: 1.5, sm: 2 },
                width: "100%",
                maxWidth: 560,
                backgroundColor: "transparent",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                justifyContent: "center"
            }}>
            <div
                style={{
                    position: "absolute",
                    inset: "min(-2rem, -30%) 0px 0px",
                    background: "linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 75%, rgb(255, 255, 255) 100%)",
                    borderBottomLeftRadius: 4,
                    borderBottomRightRadius: 4
                }}>
            </div>
            <Box
                ml={2}
                mr={2}
                width={"100%"}
                // height={42}
                display={"flex"}
                justifyContent={"space-between"}>
                <QuantityButton restaurantOfferStore={restaurantOfferStore} />
                <AddOrEditButton restaurantOfferStore={restaurantOfferStore} />
            </Box>
        </Paper>
    )
})

export default BottomAction;